import React, { useEffect } from "react";

import HubActionDialog from "../HubActionDialog/HubActionDialog";
import { useGetOutboundShipData, usePutShipOrderData } from "../../hooks";
import OutboundServiceOrderContent from "./OutboundServiceOrderContent";

export const OutboundServiceOrderDialog = ({
  poNumber = false,
  onClose = () => {},
  locationId = 1,
  ...rest
}) => {
  const { data, isLoading: isGetLoading } = useGetOutboundShipData(poNumber);
  const {
    mutate: ship,
    isLoading: isPutLoading,
    isSuccess,
  } = usePutShipOrderData();
  const isLoading = isPutLoading || isGetLoading;

  useEffect(() => {
    if (isSuccess) onClose();
  }, [isSuccess]);

  const onSubmit = (formData) => {
    const payload = {
      id: data?.id,
      userId: formData.userId,
    };
    if (data?.id) ship(payload);
  };

  const isShipped = !!data?.shipDate;
  const isCompleted = !!data?.completionDate;

  let description = `${data?.poNumber} has NOT been shipped, you are attempting to mark this shipment as sent. Doing so will NOT impact work order routings associated to shipment, if any.`;
  if (isShipped && !isCompleted) {
    description = `${data?.poNumber} has been shipped, you are attempting to mark this shipment as confirmed. Doing so will update work order routings associated to shipment, if any.`;
  } else if (isCompleted) {
    description = `${data?.poNumber} has been completed, there is no further action for this Purchase Order.`;
  }

  const disabled = !poNumber || isLoading || !data?.id || isCompleted;

  const submitLabel = data?.id
    ? isCompleted
      ? "No Further Action"
      : isShipped
      ? "Mark as Returned"
      : "Mark as Shipped"
    : "Cannot Complete Actions";

  return (
    <HubActionDialog
      onClose={onClose}
      open={poNumber}
      title="Purchase Order Status Change!"
      description={description}
      handleSubmit={onSubmit}
      submitLabel={submitLabel}
      includeCancel={false}
      action="warning"
      disabled={disabled}
      {...rest}
    >
      <OutboundServiceOrderContent
        isLoading={isLoading}
        locationId={locationId}
      />
    </HubActionDialog>
  );
};

export default OutboundServiceOrderDialog;
